import React from 'react';
import { Hero } from "../../components/hero/Hero";
import {PersonnelContact} from "./PersonnelContact";
import {MarketingContact} from "./MarketingContact";
import {Distributors} from "../../components/distributors/Distributors";
import {ContactUsFormSection} from "../../components/contact-us/ContactUsFormSection";
import {connect} from "react-redux";
import {BasicAnimation} from "../../components/animations/BasicAnimation";
import {Helmet} from "react-helmet";

export class ContactUsViewContainer extends React.Component {


  constructor(props){
    super(props);

    let state = {
      marketing_contacts: this.props.contacts.filter( c => c.contact_categories[0] === 53 ),
      personel_contacts: this.props.contacts.filter( c => c.contact_categories[0] === 52 ),
    };

    try {
      state.heroImage = this.props.contacts._embedded["wp:featuredmedia"][0].source_url;
    } catch(e){}


    this.state = state;
  }


  render(){
    return (
      <div style={{ height: "100%" }}>
         <Helmet>
          <title>Contact Us | Obelux Aviation Lights</title>
          <meta name="description" content="Please contact Obelux Oy directly to find your local representative. Obelux Ltd. Tel: +358 9 6871 6800. Address: Kutomotie 6 B 00380 Helsinki. email: info@obelux.com"></meta>
          <meta name="og:description" content="Please contact Obelux Oy directly to find your local representative. Obelux Ltd. Tel: +358 9 6871 6800. Address: Kutomotie 6 B 00380 Helsinki. email: info@obelux.com"></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>
        <header>
          <Hero title="Contact Obelux"
                image={require('../../assets/images/Obelux-sales_blue.jpg')}
                align="center"/>
        </header>
        <BasicAnimation duration={800} delay={300}>
          <MarketingContact contacts={this.state.marketing_contacts}/>
        </BasicAnimation>
        <BasicAnimation duration={800} delay={0}>
          <PersonnelContact contacts={this.state.personel_contacts}/>
        </BasicAnimation>
        <Distributors/>
        <ContactUsFormSection/>
      </div>
    );
  }
}


export const ContactUsView = connect(
  state => ({
    contacts: ( state.resolve.data && state.resolve.data.contacts ) || [],
    contact_categories: ( state.resolve.data && state.resolve.data.contact_categories ) || []
  })
)(ContactUsViewContainer);



// WEBPACK FOOTER //
// ./src/views/contact-us/ContactUsView.js